/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Orgs_DescriptionInputs */

const en_marketing_feature_orgs_description = /** @type {(inputs: Marketing_Feature_Orgs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams with invitations, roles, member management, and an org switcher.`)
};

const es_marketing_feature_orgs_description = /** @type {(inputs: Marketing_Feature_Orgs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos con invitaciones, roles, gestión de miembros y un selector de organización.`)
};

const fr_marketing_feature_orgs_description = /** @type {(inputs: Marketing_Feature_Orgs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des équipes avec invitations, rôles, gestion des membres et un sélecteur d'organisation.`)
};

/**
* | output |
* | --- |
* | "Teams with invitations, roles, member management, and an org switcher." |
*
* @param {Marketing_Feature_Orgs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_orgs_description = /** @type {((inputs?: Marketing_Feature_Orgs_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Orgs_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_orgs_description(inputs)
	if (locale === "es") return es_marketing_feature_orgs_description(inputs)
	return fr_marketing_feature_orgs_description(inputs)
});